module.exports = __webpack_public_path__ + "img/DateTime.f8484851.svg";